module.exports = [{
  plugin: require('../../@mdx-deck/gatsby-plugin/gatsby-browser.js'),
  options: {
    "plugins": [],
    "path": "/zeit/1a1f319f/deck.mdx",
    "dirname": "/zeit/1a1f319f"
  }
}];